module.exports = __webpack_public_path__ + "static/media/online-health-info.e5a293fa.md";


//////////////////
// WEBPACK FOOTER
// ./src/md/online-health-info.md
// module id = 2888
// module chunks = 0